import _slicedToArray from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import { sortDate } from "../../utils/sort.js";
import { isNumber, isDate } from "../../utils/is.js";
export default {
  props: {
    sortMethod: {
      type: Function,
      default: function _default(data, sortBy, descending) {
        var col = this.colList.find(function (def) {
          return def.name === sortBy;
        });

        if (col === void 0 || col.field === void 0) {
          return data;
        }

        var dir = descending === true ? -1 : 1,
            val = typeof col.field === 'function' ? function (v) {
          return col.field(v);
        } : function (v) {
          return v[col.field];
        };
        return data.sort(function (a, b) {
          var A = val(a),
              B = val(b);

          if (A === null || A === void 0) {
            return -1 * dir;
          }

          if (B === null || B === void 0) {
            return 1 * dir;
          }

          if (col.sort !== void 0) {
            return col.sort(A, B, a, b) * dir;
          }

          if (isNumber(A) === true && isNumber(B) === true) {
            return (A - B) * dir;
          }

          if (isDate(A) === true && isDate(B) === true) {
            return sortDate(A, B) * dir;
          }

          if (typeof A === 'boolean' && typeof B === 'boolean') {
            return (A - B) * dir;
          }

          var _map = [A, B].map(function (s) {
            return (s + '').toLocaleString().toLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          A = _map2[0];
          B = _map2[1];
          return A < B ? -1 * dir : A === B ? 0 : dir;
        });
      }
    }
  },
  computed: {
    columnToSort: function columnToSort() {
      var sortBy = this.computedPagination.sortBy;

      if (sortBy) {
        return this.colList.find(function (def) {
          return def.name === sortBy;
        }) || null;
      }
    }
  },
  methods: {
    sort: function sort(col
    /* String(col name) or Object(col definition) */
    ) {
      if (col === Object(col)) {
        col = col.name;
      }

      var _this$computedPaginat = this.computedPagination,
          sortBy = _this$computedPaginat.sortBy,
          descending = _this$computedPaginat.descending;

      if (sortBy !== col) {
        sortBy = col;
        descending = false;
      } else if (this.binaryStateSort === true) {
        descending = !descending;
      } else if (descending === true) {
        sortBy = null;
      } else {
        descending = true;
      }

      this.setPagination({
        sortBy: sortBy,
        descending: descending,
        page: 1
      });
    }
  }
};